module.exports = __webpack_public_path__ + "img/a220b8b9264b23d9c27bb8e916ebf803.4cafab7f.png";